import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { BrowserModule } from '@angular/platform-browser';
import { DashboardModule } from './../dashboard/dashboard.module';
import { DxSharedModule } from './../../shared/dx-shared.module';
import { SharedModule } from './../../shared/shared.module';
import { NgModule, enableProdMode, APP_INITIALIZER } from '@angular/core';

import { AppComponent } from './app.component';
import { ScreenService } from 'src/core/services/screen.service';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { JwtInterceptor } from 'src/core/interceptors/jwt.interceptor';
import { ErrorInterceptor } from 'src/core/interceptors/err.interceptor';
import { LayoutsModule } from 'src/core/layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { ControlPanelService } from 'src/states/control-panel.service';
import { NgxsModule, Select, Store } from '@ngxs/store';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { EnvService } from 'src/environments/environment';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NotificationService } from 'src/core/services/notification.service';
import { LoaderModule } from 'src/core/layouts/loader/loader.module';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { DownloadService } from 'src/core/services/downloadService';
import { ApiModule } from 'src/api/api.module';
import { RecyparcsConfigModule } from '../config/recyparcs-config.module';
import { StatistiquesModule } from '../statistiques/statistiques.module';
import { AuthImagePipe } from 'src/core/application-pipes/auth-image';

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/common/', suffix: '.json' },
    { prefix: './assets/i18n/', suffix: '.json' }
  ]);
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    CommonModule,
    SharedModule,
    DxSharedModule,
    LayoutsModule,
    DashboardModule,
    StatistiquesModule,
    AppRoutingModule,
    HttpClientModule,
    DragDropModule,
    LoaderModule,
    RecyparcsConfigModule.forRoot(EnvService.getApiURL()),
    ApiModule.forRoot({ rootUrl: EnvService.getApiURL() }),
    NgxsModule.forRoot([
      ControlPanelStore
    ]),
    NgxsModule.forFeature([]),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: true
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: EnvService.isProd() 
    }),
    NgxsRouterPluginModule.forRoot(),
    NgxsStoragePluginModule.forRoot({
      key: 'controlpanel'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (envService: EnvService) => () => envService.init(),
      deps: [EnvService],
      multi: true
    },
    ControlPanelService,
    ScreenService,
    NotificationService,
    PanelLayoutService,
    DownloadService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
